
export default function CompanyHistorySection() {
  const milestones = [
    {
      year: '2009',
      title: '公司成立',
      description: '南滇古茶正式成立，开始专注于云南茶叶的种植与加工',
      icon: 'ri-flag-line',
      image: 'https://public.readdy.ai/ai/img_res/8faadb7c31ee372ac16677d31d29d559.jpg'
    },
    {
      year: '2012',
      title: '茶园扩建',
      description: '茶园面积扩展至2万亩，建立标准化种植管理体系',
      icon: 'ri-plant-line',
      image: 'https://readdy.ai/api/search-image?query=Expanding%20tea%20plantation%20with%20newly%20planted%20tea%20bushes%20in%20organized%20rows%2C%20agricultural%20development%20and%20growth%2C%20modern%20tea%20farming%20expansion%2C%20systematic%20tea%20garden%20cultivation%2C%20green%20tea%20field%20development&width=300&height=200&seq=history-02&orientation=landscape'
    },
    {
      year: '2015',
      title: '品牌升级',
      description: '完成品牌升级，推出"南滇古茶"系列高端产品',
      icon: 'ri-award-line',
      image: 'https://readdy.ai/api/search-image?query=Premium%20tea%20product%20packaging%20display%20with%20elegant%20branding%2C%20luxury%20tea%20collection%20showcase%2C%20high-end%20tea%20product%20presentation%2C%20sophisticated%20brand%20upgrade%20presentation%2C%20premium%20tea%20brand%20identity&width=300&height=200&seq=history-03&orientation=landscape'
    },
    {
      year: '2018',
      title: '质量认证',
      description: '获得ISO9001质量管理认证和有机茶认证',
      icon: 'ri-shield-check-line',
      image: 'https://readdy.ai/api/search-image?query=Quality%20certification%20ceremony%20with%20official%20certificates%20and%20awards%2C%20professional%20quality%20assurance%20recognition%2C%20ISO%20certification%20presentation%2C%20organic%20tea%20certification%20achievement%2C%20quality%20standard%20milestone&width=300&height=200&seq=history-04&orientation=landscape'
    },
    {
      year: '2020',
      title: '数字化转型',
      description: '启动数字化转型，建立产品溯源系统和线上销售平台',
      icon: 'ri-smartphone-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20technology%20integration%20in%20tea%20business%2C%20digital%20transformation%20with%20computers%20and%20mobile%20devices%2C%20online%20platform%20development%2C%20technology-enhanced%20tea%20business%20operations%2C%20digital%20innovation%20in%20traditional%20industry&width=300&height=200&seq=history-05&orientation=landscape'
    },
    {
      year: '2024',
      title: '全国布局',
      description: '完成全国市场布局，合作伙伴遍布各大城市',
      icon: 'ri-earth-line',
      image: 'https://readdy.ai/api/search-image?query=National%20business%20expansion%20with%20map%20showing%20nationwide%20coverage%2C%20successful%20business%20growth%20across%20China%2C%20market%20expansion%20visualization%2C%20nationwide%20distribution%20network%2C%20comprehensive%20market%20presence&width=300&height=200&seq=history-06&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            发展历程
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            从小茶园到行业领军者，见证南滇古茶15年的成长之路
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-blue-500 to-blue-700 hidden lg:block"></div>

          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <div
                key={index}
                className={`flex flex-col lg:flex-row items-center gap-8 ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Content */}
                <div className="flex-1 lg:max-w-md">
                  <div className={`bg-white rounded-2xl shadow-lg p-6 ${
                    index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'
                  } hover:shadow-xl transition-shadow duration-300`}>
                    <div className="flex items-center justify-center lg:justify-start mb-4">
                      <div className={`w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center mr-3 ${
                        index % 2 === 0 ? 'lg:order-2 lg:mr-0 lg:ml-3' : ''
                      }`}>
                        <i className={`${milestone.icon} text-white text-xl`}></i>
                      </div>
                      <div className={`${index % 2 === 0 ? 'lg:order-1' : ''}`}>
                        <div className="text-xl md:text-2xl lg:text-3xl font-bold text-blue-600">{milestone.year}</div>
                      </div>
                    </div>
                    
                    <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-3">
                      {milestone.title}
                    </h3>
                    
                    <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                      {milestone.description}
                    </p>
                  </div>
                </div>

                {/* Timeline dot */}
                <div className="hidden lg:block relative z-10">
                  <div className="w-6 h-6 bg-blue-500 rounded-full border-4 border-white shadow-lg"></div>
                </div>

                {/* Image */}
                <div className="flex-1 lg:max-w-md">
                  <img
                    src={milestone.image}
                    alt={milestone.title}
                    className="w-full h-64 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Future Vision */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white text-center">
          <h3 className="text-xl md:text-2xl font-bold mb-4">未来愿景</h3>
          <p className="text-blue-100 text-base md:text-lg mb-6 max-w-3xl mx-auto">
            到2030年，我们将建成中国最具影响力的茶叶品牌，推动云南茶叶走向世界，让更多人品味到正宗的中国茶文化
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <div className="text-xl md:text-2xl font-bold text-amber-400 mb-2">10万亩</div>
              <div className="text-blue-100 text-xs md:text-sm">目标茶园面积</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <div className="text-xl md:text-2xl font-bold text-amber-400 mb-2">1000+</div>
              <div className="text-blue-100 text-xs md:text-sm">合作伙伴</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <div className="text-xl md:text-2xl font-bold text-amber-400 mb-2">全球化</div>
              <div className="text-blue-100 text-xs md:text-sm">国际市场布局</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
